function isVisible(el: HTMLElement): boolean {
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  if (Number(style.opacity) < 0.05) return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

/** EP 遮罩内是否有可见弹窗内容（避免只剩透明层挡触摸） */
function overlayHasVisibleDialog(overlay: HTMLElement): boolean {
  const dlg = overlay.querySelector(
    '.el-dialog, .el-overlay-dialog',
  ) as HTMLElement | null;
  if (!dlg || !isVisible(dlg)) return false;
  const rect = dlg.getBoundingClientRect();
  if (rect.width < 8 || rect.height < 8) return false;
  const panel = overlay.querySelector('.popup-box') as HTMLElement | null;
  if (panel && !isVisible(panel)) return false;
  return true;
}

function unlockScrollLock(node: HTMLElement): void {
  node.style.overflow = '';
  node.style.paddingRight = '';
  node.style.removeProperty('pointer-events');
  node.classList.remove('el-popup-parent--hidden');
}

/** 解除 body 滚动锁定，并清理无对应弹窗的残留遮罩（勿在弹窗仍打开时 remove 活跃层）。 */
export function releaseBlockingOverlays(reason?: string): void {
  if (typeof document === 'undefined') return;

  document.querySelectorAll('.el-overlay').forEach((el) => {
    const node = el as HTMLElement;
    const style = window.getComputedStyle(node);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number(style.opacity) < 0.05
    ) {
      node.remove();
      return;
    }
    if (overlayHasVisibleDialog(node)) return;
    node.remove();
  });

  document.querySelectorAll('.global-loading').forEach((el) => {
    const node = el as HTMLElement;
    if (!isVisible(node)) node.remove();
  });

  document.querySelectorAll('[data-custom-popover-overlay]').forEach((el) => {
    const node = el as HTMLElement;
    const box = node.querySelector('.popover-box') as HTMLElement | null;
    if (box && isVisible(box)) return;
    node.remove();
  });

  document.querySelectorAll('.v-loading-mask').forEach((el) => {
    const node = el as HTMLElement;
    const parent = node.parentElement;
    if (parent?.classList.contains('el-loading-parent--relative')) {
      parent.classList.remove('el-loading-parent--relative');
    }
    node.remove();
  });

  document.querySelectorAll('.el-popup-parent--hidden').forEach((el) => {
    unlockScrollLock(el as HTMLElement);
  });

  for (const node of [document.body, document.documentElement]) {
    if (!node) continue;
    unlockScrollLock(node);
  }

  if (reason) {
    console.info('[live] releaseBlockingOverlays:', reason);
  }
}

export function registerReleaseBlockingOverlaysHook(): void {
  if (typeof window === 'undefined') return;
  (window as Window & { __AIMETA_RELEASE_BLOCKING_UI__?: () => void }).__AIMETA_RELEASE_BLOCKING_UI__ =
    () => releaseBlockingOverlaysIfIdle('native-hook');
}

export function hasOpenElementPlusDialog(): boolean {
  if (typeof document === 'undefined') return false;
  return [...document.querySelectorAll('.el-overlay')].some((el) =>
    overlayHasVisibleDialog(el as HTMLElement),
  );
}

export function releaseBlockingOverlaysIfIdle(reason?: string): void {
  if (hasOpenElementPlusDialog()) return;
  releaseBlockingOverlays(reason);
}

/** 关播/清理进度 UI 后延迟再试一次，应对弹窗关闭动画。 */
export function scheduleReleaseBlockingOverlays(
  reason?: string,
  delaysMs: number[] = [0, 300],
): void {
  delaysMs.forEach((ms) => {
    if (ms <= 0) {
      releaseBlockingOverlays(reason);
      return;
    }
    window.setTimeout(() => releaseBlockingOverlays(reason), ms);
  });
}
